module.exports = __webpack_public_path__ + "static/media/instagram.bb3fda5c.svg";